import { ModalOverlay, type StackProps } from '@chakra-ui/react';

export type UiModalOverlayProps = StackProps;

export const UiModalOverlay = ModalOverlay;
